import { CustomSelect } from 'components';
import { CustomSelectProps } from 'components/CustomSelect/CustomSelect.props';
import useMeasurementDateListOptions from 'pages/Waterfall/components/MeasurementDateList/useMeasurementDateListOptions';

const MeasurementDateList = (props: CustomSelectProps) => {
  const { cell, onCommit, onRevert } = props;

  const { options } = useMeasurementDateListOptions();

  return (
    <CustomSelect
      autoFocus
      id="measurement-date-list"
      menuPlacement="bottom"
      onCommit={onCommit}
      onEmptyValue=""
      onRevert={onRevert}
      openMenuOnFocus
      options={options}
      value={cell.value as string}
    />
  );
};

export default MeasurementDateList;
